import { Component } from '@angular/core';
import { adjectives } from './adjectives';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'いらっしゃいませ!';

  constructor(private toastr: ToastrService) {
    this.nextAdjective();
  }

  //#region modes

  modes = [ 'negative', 'past', 'past-negative' ];
  mode = null;

  selectMode = function(mode) {
    this.mode = mode;
  }

  //#endregion

  //#region adjectives
  adjectives = adjectives;
  currentAdjective = null;
  answer = { text: '' };

  nextAdjective() {
    this.currentAdjective = adjectives[Math.floor((Math.random()*adjectives.length))];
  }

  submitAnswer() {
    let correctAnswer = this.getCorrectAnswer();
    if (this.answer.text != correctAnswer) {
      this.toastr.error(correctAnswer, 'ちがいます!', {
        disableTimeOut: true,
        closeButton: true        
      });
    }
    else {
      this.toastr.success('せいかいです!');

      this.answer.text = '';
      this.nextAdjective();
    }
  }

  getCorrectAnswer() {
    if (this.currentAdjective.type == 'na') {
      if (this.mode == 'negative') {
        return this.currentAdjective.text + 'じゃない';
      }
      else if (this.mode == 'past') {
        return this.currentAdjective.text + 'でした';
      }
      else {
        // past-negative
        return this.currentAdjective.text + 'じゃなかった';
      } 
    }
    else if (this.currentAdjective.type == 'i') {
      if (this.mode == 'negative') {
        return this.currentAdjective.text.substring(0, this.currentAdjective.text.length -1) + 'くない';
      }
      else if(this.mode == 'past') {
        return this.currentAdjective.text.substring(0, this.currentAdjective.text.length -1) + 'かった';
      }
      else {
        // past-negative
        return this.currentAdjective.text.substring(0, this.currentAdjective.text.length -1) + 'くなかった';
      }
    }
    else {
      // catch-all for ii
      if (this.mode == 'negative') {
        return 'よくない';
      }
      else if (this.mode == 'past') {
        return 'よかった';
      }
      else {
        // past-negative
        return 'よくなかった';
      }
    }
  }

  //#endregion
}
